import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    margin-top: 15px;
    margin-bottom: 10px;
    color: ${colors.white};

    select, input {
      background-position: 98% 50%;
      background-size: 15px 15px;
    }

    span {
      font-weight: 300;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;

  .address, .city, .province, .zipCode, .country {
    width: 100%;
    min-width: 60px;
    position: relative;

    .label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  ${({ additionalstyle }) => additionalstyle};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
`;